import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({name: 'timestamp'})
export class TimestampPipe implements PipeTransform {
    transform(value) {
        return value ? dayjs.unix(value).format('DD.MM.YYYY') : value;
    }
}
